import React, { useEffect, useState, useRef } from "react";
import ExcelExport from "../../ExcelExport";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../../Sidebar";
import { filterBasedFileNameGenerator } from "../../../utils/filterBasedFileNameGenerator";
import { useEmptyFiltersCheck } from "../../../hooks/useEmptyFiltersCheck";
import { useMultiDelete } from "../../../hooks/useMultiDelete";
//Prices upload field
import ReactPaginate from "react-paginate";

export default function JodiaBazarTable({ productName }) {
  const [prices, setPrices] = useState([]);
  const [filteredPrices, setFilteredPrices] = useState([]);
  const [todate, setTodate] = useState("");
  const [todateformat, setTodateformat] = useState("");
  const [disable, setDisable] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [selectedStation, setSelectedStation] = useState([]);
  const [todayMessage, setTodayMessage] = useState("Today");
  const [dateDesign, setDateDesign] = useState("");
  const [stationsOptions, setStationOptions] = useState([]);
  //CHECK FOR THE VALUE
  const [todayCheck, setTodayCheck] = useState(false);
  //By Products are being fetched dynamically too
  const [byProductsList, setByProductsList] = useState();
  //Const filtering dates
  const [filter, setFilter] = useState({
    startDate: "",
    endDate: "",
    mill_name: "",
    station: "",
    district: "",
    province: "",
  });
  const [wrapperFilter, setWrapperFilter] = useState({
    by_product: "jodia_bazaar"
  })
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 100,
    total: "",
    pages: "",
  });
  const emptyFilters = useEmptyFiltersCheck(filter);
  //Multi delete functionality
  const {
    markedForDeletion,
    handleAllCheckboxChange,
    handleCheckboxChange,
    handleInArray,
    resetArray,
  } = useMultiDelete();
  //Pagination
  const [page, setPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(20);
  const [pageCount, setPageCount] = useState();
  const token = sessionStorage.getItem("token");
  const getStations = async () => {
    if (token) {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/admin/stations`,
        {
          headers: {
            "x-access-token": token,
          },
        }
      );
      const data = await response.json();
      setStationOptions(data);
    } else {
      console.log("No token!");
    }
  };

  useEffect(() => {
    async function getByProductsList() {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/admin/mills`,
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      const data = await response.json();
      setByProductsList(data);
    }

    getByProductsList();
  }, []);

  const fetchData = async () => {
    const token = sessionStorage.getItem("token");
    const query = Object.keys(filter)
      .filter((key) => filter[key] !== "")
      .map((key) => `${key}=${filter[key]}`)
      .join("&");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/admin/prices?by_product=jodia_bazaar&${query}&page=${pagination.page}&limit=${pagination.limit}`,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );

    if (response.status == 404) {
      setPrices([]);
    }

    if (response.status == 200) {
      const data = await response.json();
      setPrices(data.prices);
      const pageCountValue = Math.ceil(
        data.totalPriceRecords / data.itemsPerPage
      );
      setPageCount(pageCountValue);
    }
  };

  useEffect(() => {
    resetArray();
    fetchData();

    setWrapperFilter(prevWrapperFilter => ({
      ...prevWrapperFilter,         
      ...filter,                 
      by_product: prevWrapperFilter.by_product 
    }));
  }, [filter, pagination]);

  const totalPages = Math.ceil(filteredPrices.length / postsPerPage);
  const pageRange = 10; // Number of page buttons to show at a time

  const startPage = Math.max(1, page - Math.floor(pageRange / 2));
  const endPage = Math.min(totalPages, startPage + pageRange - 1);

  const pageButtons = [...Array(endPage - startPage + 1)].map(
    (_, i) => startPage + i
  );
  useEffect(() => {
    getStations();
  }, []);

  const lastPostIndex = page * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  // const currentPrices = filteredPrices.slice(firstPostIndex, lastPostIndex)
  const currentPrices = filteredPrices;
  const selectPageHandler = (selectedPage) => {
    setPage(selectedPage);
  };

  //handle to date -
  const handletodate = (e) => {
    setFilter({ ...filter, endDate: e.target.value });
  };
  useEffect(() => {
    console.log(
      "Here is the selected end date " +
        todate +
        "Original format: " +
        todateformat
    );
    console.log(new Date(todate));
  }, [todateformat]);

  //handle from date
  const handlefromdate = (e) => {
    setFilter({ ...filter, startDate: e.target.value });
  };

  // Initial state setup and filtering logic
  useEffect(() => {
    // Call the function to set the initial filtered data with all prices
    setFilteredPrices(prices);
  }, [prices]);

  //The Delete Button
  const handleDelete = async (itemId) => {
    const token = sessionStorage.getItem("token");
    await fetch(`${process.env.REACT_APP_API_URL}/admin/prices/${itemId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    });
    setPrices((prevData) => prevData.filter((item) => item._id != itemId));
  };

  //edit page
  const navigate = useNavigate();

  function formatDate(date) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    const dayOfWeek = days[date.getDay()]; // Get day of the week
    const month = months[monthIndex]; // Get month name

    const formattedDateString = `${dayOfWeek}, ${day}${getDaySuffix(
      day
    )} ${month} ${year}`;

    return formattedDateString;
  }

  function getDaySuffix(day) {
    if (day >= 11 && day <= 13) {
      return "th";
    }
    const lastDigit = day % 10;
    if (lastDigit === 1) {
      return "st";
    } else if (lastDigit === 2) {
      return "nd";
    } else if (lastDigit === 3) {
      return "rd";
    }
    return "th";
  }

  useEffect(() => {
    if (selectedProducts.length == 0) {
      setFilter({ ...filter, mill_name: "" });
    } else {
      let appendedString = "";

      selectedProducts.forEach((product) => {
        if (selectedProducts[0].name == product.name) {
          appendedString += product.name;
        } else {
          appendedString += "," + product.name;
        }
      });
      setFilter({ ...filter, mill_name: appendedString });
    }
  }, [selectedProducts]);

  useEffect(() => {
    if (selectedProvince.length === 0) {
      setFilter({ ...filter, province: "" });
    } else {
      setFilter({ ...filter, province: selectedProvince[0].name });
    }
  }, [selectedProvince]);

  useEffect(() => {
    if (selectedDistrict.length === 0) {
      setFilter({ ...filter, district: "" });
    } else {
      setFilter({ ...filter, district: selectedDistrict[0].name });
    }
  }, [selectedDistrict]);

  useEffect(() => {
    if (selectedStation.length === 0) {
      setFilter({ ...filter, station: "" });
    } else {
      setFilter({ ...filter, station: selectedStation[0].name });
    }
  }, [selectedStation]);

  const deleteMultiple = async () => {
    const ids = { ids: markedForDeletion };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/admin/prices`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
          body: JSON.stringify(ids),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error:", errorData.message);
      } else {
        const data = await response.json();
        setPrices((prevData) =>
          prevData.filter((item) => !markedForDeletion.includes(item._id))
        );
        resetArray();
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > pagination.pages) return;
    setPagination({ ...pagination, page: newPage });
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= pagination.pages; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${i === pagination.page ? "active" : ""}`}
        >
          <a
            className="page-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pageNumbers;
  };

  useEffect(() => {
    renderPageNumbers();
  }, []);

  const handlePageClick = (event) => {
    setPagination({ ...pagination, page: event.selected + 1 });
  };
  return (
    <>
      <div className="sidebar">
        <Sidebar />
        <h2 id="tabler">Jodia Bazar Rates</h2>
      </div>
      <div id="tabler1">
        <div className="tables-option-div">
          <div className="row">
            <div className="col">
              <div className="tables-options">
                <ExcelExport
                  url={`${process.env.REACT_APP_API_URL}/admin/prices`}
                  filter={wrapperFilter}
                  fileName={filterBasedFileNameGenerator(filter)}
                />
              </div>
            </div>

            <div className="col">
              <div className="tables-options">
                <Link to="/jodia-bazar-form">
                  {" "}
                  <button type="button" class="btn table-buttons">
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-plus-square-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                    </svg>{" "}
                    Create New
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/**Form for different filters */}
        {!todayCheck && (
          <form>
            <div class="container">
              <div class="row">
                <div class="col">
                  <div class="mb-3">
                    <label for="formGroupExampleInput2" class="form-label">
                      From
                    </label>
                    <input
                      type="date"
                      class="form-control"
                      id="formGroupExampleInput2"
                      onChange={handlefromdate}
                    />
                  </div>
                </div>
                <div class="col">
                  <div class="mb-3">
                    <label for="formGroupExampleInput2" class="form-label">
                      To
                    </label>
                    <input
                      type="date"
                      class="form-control"
                      id="formGroupExampleInput2"
                      onChange={handletodate}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
        {todayCheck && (
          <div>
            <h3 style={{ color: "gray" }}>
              Commodity prices for {formatDate(new Date())}
            </h3>
          </div>
        )}

        {!emptyFilters && (
          <div className="row">
            <div className="col">
              <div className=" d-flex justify-content-end">
                <button
                  type="button"
                  class="btn btn-danger"
                  onClick={deleteMultiple}
                >
                  Delete Selected Items
                </button>
              </div>
            </div>
          </div>
        )}
        <table class="table" id="table1">
          <thead>
            <tr>
              {!emptyFilters && (
                <th>
                  <input
                    type="checkbox"
                    aria-label="Checkbox for following text input"
                    onChange={() => handleAllCheckboxChange(prices)}
                  />
                </th>
              )}
              <th scope="col" id="field1">
                Date
              </th>
              <th scope="col">Station</th>
              <th scope="col">DO Price</th>
              <th scope="col">Delivered</th>
              <th scope="col">Wholesale</th>
              {emptyFilters && <th scope="col">Delete</th>}
              <th scope="col">Edit</th>
            </tr>
          </thead>

          <tbody>
            {prices &&
              prices.map((price, index) => (
                <tr key={price._id}>
                  {!emptyFilters && (
                    <td>
                      <input
                        id={price._id}
                        type="checkbox"
                        checked={handleInArray(price._id)}
                        aria-label="Checkbox for following text input"
                        onChange={() => handleCheckboxChange(price._id)}
                      />
                    </td>
                  )}
                  <th scope="row text-nowrap">{price.date.split("T")[0]}</th>
                  <td>{price.station}</td>
                  <td>{price.do_price}</td>
                  <td>{price.delivered}</td>
                  <td>{price.wholesale}</td>
                  {emptyFilters && (
                    <td>
                      <button
                        type="button"
                        class="btn btn-danger"
                        onClick={() => handleDelete(price._id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />{" "}
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                        </svg>
                      </button>
                    </td>
                  )}
                  <td>
                    {" "}
                    <Link
                      type="button"
                      class="btn btn-info"
                      to={`/jodia-bazar-update/${price._id}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-pencil-square"
                        viewBox="0 0 16 16"
                      >
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path
                          fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                        />
                      </svg>
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        {prices && (
          <ReactPaginate
            className="my-paginator"
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
          />
        )}
        {!prices && (
          <div class="alert alert-primary" role="alert">
            Oops! Something went wrong.
          </div>
        )}
      </div>
    </>
  );
}
